import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';
import Select from './ui/Select';
import Input from './ui/Input';

const QuickBookingWidget = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    urgency: '',
    preferredTime: '',
    concern: '',
  });

  const urgencyOptions = [
    { value: 'immediate', label: 'Immediate (within 24 hours)' },
    { value: 'soon', label: 'Soon (within 3 days)' },
    { value: 'flexible', label: 'Flexible (within 2 weeks)' },
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    navigate('/booking-scheduling', { state: { quickBooking: formData } });
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="quick-booking-widget">
      <div className="quick-booking-header">
        <Icon name="Calendar" size={24} className="text-primary" />
        <h3 className="quick-booking-title">Quick Booking</h3>
      </div>
      <form onSubmit={handleSubmit} className="quick-booking-form">
        <Select
          label="How soon do you need support?"
          placeholder="Select urgency level"
          options={urgencyOptions}
          value={formData?.urgency}
          onChange={(value) => handleChange('urgency', value)}
          required
        />

        <Input
          label="Preferred time"
          type="datetime-local"
          value={formData?.preferredTime}
          onChange={(e) => handleChange('preferredTime', e?.target?.value)}
          description="We'll match you with available helpers"
        />

        <Input
          label="Brief concern description"
          type="text"
          placeholder="What brings you here today?"
          value={formData?.concern}
          onChange={(e) => handleChange('concern', e?.target?.value)}
          description="Optional - helps us match you better"
        />

        <Button
          type="submit"
          variant="default"
          iconName="ArrowRight"
          iconPosition="right"
          fullWidth
          disabled={!formData?.urgency}
        >
          Find Available Helpers
        </Button>
      </form>
    </div>
  );
};

export default QuickBookingWidget;